import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
  styled,
  useTheme,
} from "@mui/material";

import NumberFormats from "components/NumberFormats";
import { SpaceBetweenBox } from "components/GeneralStyled";
import { useNavigate } from "react-router-dom";
import { SuccessCheckIcon } from "assets/Icon";
import SuccessPattern from "assets/images/success-pattern.png";

function SuccessPayment({ depositVerify }) {
  const navigate = useNavigate();
  const theme = useTheme()


  return (
    <Container maxWidth="sm">
      <Grid container>
        <Grid item xs="12">
          <BoxStyle>
            <Grid container justifyContent="center" spacing={2} mt={2}>
              <Grid item xs="12">
                <BoxIcon>
                  <SuccessCheckIcon fill={theme.palette.modules.successModalBg} stroke={theme.palette.modules.successModalBgBorder} />
                  <SuccessPatternImg src={SuccessPattern} alt="" />
                </BoxIcon>

                <Typography color={'success.main'} typography={"h3"} textAlign={"center"} fontWeight={600}>
                  Deposit Successful
                </Typography>

                <Typography color={'text.secondary'} typography={"subtitle1"} textAlign={"center"}>
                  Your deposit has been received and credited to your account.
                </Typography>

                <Box mt={3}>
                  <SpaceBetweenBox>
                    <Typography color="text.secondary" variant="h6">
                      Coin
                    </Typography>

                    <Typography variant="h5" color="text.main">
                      {depositVerify.coinName}
                    </Typography>
                  </SpaceBetweenBox>

                  <SpaceBetweenBox>
                    <Typography color="text.secondary" variant="h6">
                      Amount
                    </Typography>

                    <Typography variant="h5" color="text.main">
                      <NumberFormats value={depositVerify?.amount} />{" "}
                      <Typography component="span">
                        {depositVerify?.coinName}
                      </Typography>
                    </Typography>
                  </SpaceBetweenBox>

                  <SpaceBetweenBox>
                    <Typography color="text.secondary" variant="h6">
                      Fee
                    </Typography>

                    <Typography variant="h5" color="text.main">
                      <NumberFormats value={depositVerify?.fee} />{" "}
                      <Typography component="span">
                        {depositVerify?.coinName}
                      </Typography>
                    </Typography>
                  </SpaceBetweenBox>

                  <SpaceBetweenBox>
                    <Typography color="text.secondary" variant="h6">
                      State
                    </Typography>

                    <Typography variant="h5" color="text.main">
                      {depositVerify?.state}
                    </Typography>
                  </SpaceBetweenBox>

                  <SpaceBetweenBox>
                    <Typography color="text.secondary" variant="h6">
                      Type
                    </Typography>

                    <Typography variant="h5" color="text.main">
                      {depositVerify?.type}
                    </Typography>
                  </SpaceBetweenBox>

                  <SpaceBetweenBox>
                    <Typography color="text.secondary" variant="h6">
                      Wallet Type
                    </Typography>

                    <Typography variant="h5" color="text.main">
                      {depositVerify?.walletType}
                    </Typography>
                  </SpaceBetweenBox>

                  <SpaceBetweenBox>
                    <Typography color="text.secondary" variant="h6">
                      Side
                    </Typography>

                    <Typography variant="h5" color="text.main">
                      {depositVerify?.side}
                    </Typography>
                  </SpaceBetweenBox>

                  <SpaceBetweenBox>
                    <Typography color="text.secondary" variant="h6">
                      Date Time
                    </Typography>

                    <Typography variant="h5" color="text.main">
                      {depositVerify?.date} {depositVerify?.time}
                    </Typography>
                  </SpaceBetweenBox>
                </Box>
              </Grid>

              <Grid item xs="6">
                <Button
                  color="success"
                  fullWidth
                  onClick={() => navigate("/deposit/4?isDigital=false&type=4")}
                >
                  بازگشت
                </Button>
              </Grid>
            </Grid>
          </BoxStyle>
        </Grid>
      </Grid>
    </Container>
  );
}

const BoxStyle = styled(Box)(({ theme }) => ({
  background: theme.palette.background.primaryGradient,
  padding: theme.spacing(2),
  textAlign: "center",
  borderRadius: "8px",
}));

const BoxIcon = styled(Box)(({ theme }) => ({
  paddingBottom: theme.spacing(5),
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  "svg": {
    width: "60px",
    height: "60px",
    zIndex: "1"
  },
}));

const SuccessPatternImg = styled('img')(({ theme }) => ({
  position: "absolute",
  maxWidth: "160px",
  zIndex: "0"
}));



export default SuccessPayment;
